import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-facility-style',
  templateUrl: './facility-style.component.html',
  styleUrls: ['./facility-style.component.scss']
})
export class FacilityStyleComponent implements OnInit {

    public SelectedLanguage: string = "en";
    constructor(public translate: TranslateService) {

        if (this.translate.currentLang != undefined) {
            this.SelectedLanguage = this.translate.currentLang;
        }
        if (this.SelectedLanguage == 'ar') {
            this.facilityContent1 = [
                {
                    icon: 'flaticon-tap',
                    title: 'تسوق أونلاين',
                    paragraph: 'تسوق سهل وبسيط ودفع آمن'
                },
                {
                    icon: 'bx bxs-plane-take-off',
                    title: 'شحن مجاني',
                    paragraph: 'شحن سريع ومجانا لبعض المناطق'
                },
                {
                    icon: 'bx bx-info-square',
                    title: 'عروض مذهلة',
                    paragraph: 'نوفر أفضل العروض لمنتجاتنا'
                }]
        }

    }

    ngOnInit(): void {

    }

    facilityContent1 = [
        {
            icon: 'bx bx-shopping-bag',
            title: 'Customer Support',
            paragraph: '24/7 We are customer care best support.'
        },
        {
            icon: 'bx bxs-plane-take-off',
            title: 'Secure Payments',
            paragraph: 'Pay with the worlds top payment methods.'
        },
        {
            icon: 'bx bx-info-square',
            title: 'GCC Delivery',
            paragraph: 'What you want, delivered to where you want.'
        }
    ]
}
